/**
 * @generated SignedSource<<b22d4ff882b35da28ba2dc388cdab6b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiscountDuration = "FIRST_ONLY" | "N_MONTHS" | "RECURRING" | "%future added value";
export type DiscountType = "FIXED" | "PERCENTAGE" | "%future added value";
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type PromotionalCodeQuery$variables = {};
export type PromotionalCodeQuery$data = {
  readonly adminPromotionalCodes: ReadonlyArray<{
    readonly appliesTo: ReadonlyArray<PlanSlug>;
    readonly code: string;
    readonly createdAt: any;
    readonly currentUses: number;
    readonly discountDuration: DiscountDuration;
    readonly discountType: DiscountType | null;
    readonly discountValue: number | null;
    readonly durationMonths: number;
    readonly expiresAt: any | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly maxUses: number;
    readonly plan: PlanSlug | null;
    readonly planName: string | null;
    readonly planValueCents: number | null;
  }>;
};
export type PromotionalCodeQuery = {
  response: PromotionalCodeQuery$data;
  variables: PromotionalCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PromotionalCode",
    "kind": "LinkedField",
    "name": "adminPromotionalCodes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planValueCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountDuration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMonths",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliesTo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxUses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionalCodeQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PromotionalCodeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c765d1518f7f4cb41c925c164899745a",
    "id": null,
    "metadata": {},
    "name": "PromotionalCodeQuery",
    "operationKind": "query",
    "text": "query PromotionalCodeQuery {\n  adminPromotionalCodes {\n    id\n    code\n    plan\n    planName\n    planValueCents\n    discountType\n    discountValue\n    discountDuration\n    durationMonths\n    appliesTo\n    isActive\n    maxUses\n    currentUses\n    expiresAt\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "646aa5b6545beaee2a113c2206db5d80";

export default node;
